import React from "react"
import { useTranslation } from "react-i18next"

import { Breadcrumbs } from "~/components/Breadcrumbs/Breadcrumbs"
import { Heading } from "~/components/Heading/Heading"
import { Link } from "~/components/Link/Link"
import { Raw } from "~/components/raw"
import { Theme } from "~/components/Theme/Theme"
import { VideoWrapper } from "~/components/VideoWrapper/VideoWrapper"

// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import video from "./assets/video.mp4"
// eslint-disable-next-line css-modules/no-unused-class
import styles from "./index.module.css"

export const Hero: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Theme className={styles.Wrapper} theme="dark">
      <VideoWrapper src={video} loop />

      <div className="container">
        <Breadcrumbs />

        <div className={"grid grid--col-12"}>
          <div className={styles.Head}>
            <Heading className={styles.Title} like="h1">
              <Raw html={t("investors-and-shareholders.Hero.Title")} />
            </Heading>

            <Link href="/investors-and-shareholders/financial" view="arrow">
              <Raw html={t("investors-and-shareholders.Hero.Link.FinancialResults")} />
            </Link>
          </div>
        </div>

        {/*<Factoids />*/}
      </div>
    </Theme>
  )
}
